<div class="container">
  <div class="inputs">
    <div class="col">
      <fi-input
        maxLength="50"
        [reducedHeight]="true"
        [hintKey]="!inputData?.isOrder ? 'REQUEST_DETAIL_HEADER_MENU_OFFERNUMBER_HELPER_TEXT' : 'REQUEST_DETAIL_HEADER_MENU_ORDERNUMBER_HELPER_TEXT'"
        [labelKey]="inputData?.isOrder ? 'GENERAL_TEXT_ORDER_NUMBER' : 'GENERAL_TEXT_OFFER_NUMBER'"
        [errorKey]="extendedProperties.NAME ? 'REQUEST_DETAIL_HEADER_MENU_ORFFERS_ORDERS_INPUT_ERROR_TEXT' : ''"
        [selectedOptionsOrValues]="extendedProperties.NAME"
        [hasError]="inValidTextNumber"
        [additionalContentPosition]="!inputData?.isOrder ? 'END' : 'NONE'"
        (onChange)="extendedProperties.NAME = $event; inValidTextNumber = false"
        >
      </fi-input>
    </div>

    <div class="col">
      <fi-input
        maxLength="12"
        [reducedHeight]="true"
        hintKey="REQUEST_DETAIL_HEADER_MENU_AMOUNT_HELPER_TEXT"
        [errorKey]="extendedProperties.AMOUNT ? 'FORM_INVALID_FIELDS' : ''"
        [labelKey]="inputData?.isOrder ? 'GENERAL_TEXT_ORDER_AMOUNT' : 'GENERAL_TEXT_OFFER_AMOUNT'"
        [selectedOptionsOrValues]="extendedProperties.AMOUNT"
        [hasError]="inValidOfferAmount"
        (onChange)="extendedProperties.AMOUNT = $event; inValidOfferAmount = false"
        >
      </fi-input>
    </div>

    <div class="col">
      <fi-input
        type="SELECT"
        [reducedHeight]="true"
        hintKey="REQUEST_DETAIL_HEADER_MENU_CURRENCY_HELPER_TEXT"
        labelKey="ACTION_APPOINTMENT_CREATE_CURRENCY"
        [selectedOptionsOrValues]="!!currencyId ? currencyId : currencies[0].Id"
        [options]="currencies"
        namePropertyPath="Description"
        (onChange)="setExtendedProperties($event);"
        >
      </fi-input>
    </div>
  </div>

  <div class="actions-box">
    <button
      [ngClass]="{'submit-btn': !showSaveAndPlaceButton, 'save-only-btn': showSaveAndPlaceButton}"
    (click)="submit(false)" fiTranslation="ALT_TEXT_REQUEST_LIST_SAFE"></button>

    @if (showSaveAndPlaceButton) {
      <button class="submit-btn" (click)="submit(true)" fiTranslation="REQUEST_OVERLAY_ADD_ORDER_SAVE_AND_PLACE_ORDER"></button>
    }
  </div>

</div>
